import { Suspense, type ReactNode } from 'react';

export function MarketingRouteBoundary({ children }: { children: ReactNode }) {
  return <Suspense fallback={null}>{children}</Suspense>;
}
